import { useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { slides, padding, colorbg, title, url, positiontitle, container } =
    attributes;
  const blockProps = useBlockProps.save({
    className: `stage ${colorbg ? 'sectiongray' : ''} ${padding}`,
  });

  const Tag = title ? 'section' : 'div';

  return (
    <>
      {slides && (
        <Tag {...blockProps}>
          <div className={container ? '' : 'container'}>
            {title && (
              <div class="row">
                <div className={`globaltitle ${positiontitle}`}>
                  <h2>{title}</h2>
                  {url && (
                    <a href={url} class="btn btn-square btn-mini btn-url">
                      Смотреть все изделия
                    </a>
                  )}
                </div>
              </div>
            )}
            {slides.map((slide, index) => (
              <div class="row g-0">
                <div class="col-md-5">
                  <div class="stage__bigitem-img">
                    <img
                      loading="lazy"
                      src={slide.image.url}
                      alt={slide.image.alt}
                      height={slide.image.height}
                      width={slide.image.width}
                    />
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="stage__bigitem-text">
                    <div class="stage__item-top-title">{slide.title}</div>
                    <p>{slide.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Tag>
      )}
    </>
  );
}
